import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const BlueprintTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={`${containerClass} bg-[#0f4c81] text-white`}>
       {/* Blueprint Grid Pattern */}
       <div className="absolute inset-0 z-0 opacity-20 pointer-events-none"
            style={{
                backgroundImage: 'linear-gradient(rgba(255,255,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.3) 1px, transparent 1px)',
                backgroundSize: '20px 20px'
            }}
       ></div>

       <div className="relative z-10 p-8 h-full flex flex-col border-8 border-white/20 m-4">
           {!hideHeader && (
             <>
               {/* Technical Header */}
               <div className="border-b-2 border-white/30 pb-6 flex justify-between items-end">
                   <div>
                       <div className="border-2 border-white/50 inline-block p-2 mb-2 bg-[#0f4c81]">
                           <span className="font-mono text-xs uppercase tracking-widest">PROJECT: {title}</span>
                       </div>
                       <h1 className="text-4xl font-bold uppercase tracking-tight">{profile.name}</h1>
                   </div>
                   <div className="text-right font-mono text-sm">
                       <div className="border border-white/30 p-2 inline-block bg-[#0f4c81]">
                           <p className="text-xs opacity-70">DOC TYPE</p>
                           <p className="font-bold">{type}</p>
                       </div>
                   </div>
               </div>

               <div className="grid grid-cols-2 border-b-2 border-white/30 h-40">
                   <div className="border-r-2 border-white/30 p-4">
                       <p className="font-mono text-xs opacity-60 mb-1">CLIENT_REF</p>
                       {client ? (
                           <>
                               <p className="font-bold text-lg">{client.name}</p>
                               <p className="font-mono text-sm opacity-80">{client.company}</p>
                           </>
                       ) : <span className="opacity-50">NULL</span>}
                   </div>
                   <div className="p-4 grid grid-cols-2 gap-4">
                       {metaData.map((m, i) => (
                           <div key={i}>
                               <p className="font-mono text-xs opacity-60">{m.label}</p>
                               <p className="font-bold font-mono">{m.value}</p>
                           </div>
                       ))}
                   </div>
               </div>
             </>
           )}

           <div className="flex-1 p-4 blueprint-table font-mono">
               {children}
           </div>

           <div className="border-t-2 border-white/30 p-4 flex justify-between items-center font-mono text-xs">
               <div className="opacity-70">{footerNote}</div>
               <div className="border border-white/50 px-2 py-1">APPROVED</div>
           </div>
       </div>
    </div>
  );
};

export default BlueprintTemplate;